"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexDbConsulta = void 0;
const VERSION = 4;
const openIndexedDB = () => __awaiter(void 0, void 0, void 0, function* () {
    const dbResquest = window.indexedDB.open('CONSULTA', VERSION);
    let db;
    return new Promise((resolve, reject) => {
        dbResquest.onerror = event => {
            const { target } = event;
            console.error('Error on open IndexedDB: ', target.error);
            reject(target.error);
        };
        dbResquest.onupgradeneeded = event => {
            db = event.target.result;
            if (!db.objectStoreNames.contains('consulta')) {
                const objectStore = db.createObjectStore('consulta', {
                    autoIncrement: true,
                });
                objectStore.createIndex('search_id', 'search_id');
                objectStore.createIndex('cod_acervo', 'cod_acervo', {
                    unique: false,
                });
            }
            if (!db.objectStoreNames.contains('expiracao')) {
                const objectStore = db.createObjectStore('expiracao', {
                    keyPath: 'search_text',
                });
                objectStore.createIndex('search_id', 'search_id');
            }
        };
        dbResquest.onsuccess = event => {
            db = event.target.result;
            resolve(db);
        };
    });
});
const clearTables = (tables) => __awaiter(void 0, void 0, void 0, function* () {
    const db = yield openIndexedDB();
    const transaction = db.transaction(tables, 'readwrite');
    tables.forEach(x => {
        const table = transaction.objectStore(x);
        table.clear();
    });
});
const insertData = (storeName, data) => __awaiter(void 0, void 0, void 0, function* () {
    const db = yield openIndexedDB();
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);
    if (objectStore) {
        if (data === null || data === void 0 ? void 0 : data.length) {
            data.forEach((x) => objectStore.add(x));
        }
        else {
            objectStore.add(data);
        }
    }
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(true);
        };
        transaction.onerror = e => {
            reject(e);
        };
    });
});
const getBy = (storeName, value, index_name) => __awaiter(void 0, void 0, void 0, function* () {
    const db = yield openIndexedDB();
    const transaction = db.transaction([storeName], 'readonly');
    const objectStore = transaction.objectStore(storeName);
    let request;
    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.get(value);
    }
    else {
        request = objectStore.get(value);
    }
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(request.result);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
});
const deleteAllByIndex = (storeName, value, index_name) => __awaiter(void 0, void 0, void 0, function* () {
    const db = yield openIndexedDB();
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);
    let request;
    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.getAllKeys(value);
    }
    else {
        request = objectStore.getAllKeys(value);
    }
    request.onsuccess = (event) => {
        const keys = event.target.result;
        // Excluir todas as chaves encontradas
        keys.forEach(function (key) {
            objectStore.delete(key);
        });
    };
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(true);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
});
const getAllBy = (storeName, value, index_name) => __awaiter(void 0, void 0, void 0, function* () {
    const db = yield openIndexedDB();
    const transaction = db.transaction([storeName], 'readonly');
    const objectStore = transaction.objectStore(storeName);
    let request;
    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.getAll(value);
    }
    else {
        request = objectStore.getAll(value);
    }
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(request.result);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
});
exports.indexDbConsulta = {
    getBy,
    getAllBy,
    insertData,
    deleteAllByIndex,
    clearTables,
};
